import { Col, Row } from "react-bootstrap";
import RecognitionItem from "./RecognitionItem";

const RecognitionList = ({ recognitions }) => {
  if (!recognitions || recognitions.length === 0) {
    return (
      <div>
        <b>There are no recognitions yet!</b>
      </div>
    );
  }

  return (
    <Row className="honor-wall-items">
      {recognitions &&
        recognitions.map((item, index) => (
          <Col
            xs={12}
            sm={6}
            md={6}
            lg={6}
            key={index}
            className="honor-wall-item-col"
          >
            <RecognitionItem
              title={item.title}
              name={item.name}
              year={item.year}
              description={item.description}
            />
          </Col>
        ))}
    </Row>
  );
};

export default RecognitionList;
